import { ImportSteps } from "app/containers/Features/containers/TeamSettings/container/ImportExport/containers/Import/types";
import Notification from "app/containers/Features/containers/TeamSettings/container/Notification";
import ProjectTabs from "app/containers/Features/containers/TeamSettings/container/Projects/ProjectTabBar/ProjectTabs";
import React, { Suspense } from "react";
import { Projects } from "./container/Projects/Loadable";

const GeneralInfo = React.lazy(() => import("./container/GeneralInfo"));
const ProjectList = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/Projects/ProjectList"),
);
const ProjectDetails = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/Projects/ProjectDetails"),
);
const ProjectComponents = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/Projects/container/ProjectComponent"),
);
const ProjectMembers = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/Projects/ProjectsMembers"),
);
const TeamMembers = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/TeamMembers"),
);
const ProjectActiveWorkFlow = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/components/Projects/ProjectActiveWorkFlow"),
);
const ProjectWorkItems = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems"),
);
const ProjectCustomFields = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/Projects/container/CustomFields"),
);
const Archives = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/Archive"),
);
const AuditLogs = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/AuditLogs"),
);
const MySettingFeatures = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/MySetting"),
);
const ImportExportIndex = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/ImportExport/"),
);
const ImportExportRoot = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/ImportExport/containers/Root"),
);
const Export = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/ImportExport/containers/Export"),
);
const ImportIndex = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/ImportExport/containers/Import"),
);
const ImportDestination = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/ImportExport/containers/Import/containers/ImportDestination"),
);
const UploadFile = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/ImportExport/containers/Import/containers/UploadFile"),
);
const MapFields = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/ImportExport/containers/Import/containers/MapFields"),
);
const StagedData = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/ImportExport/containers/Import/containers/StagedData"),
);
const Billing = React.lazy(
  () =>
    import("app/containers/Features/containers/TeamSettings/container/Billing"),
);

const TeamSettingRouting = [
  {
    path: ":id/general-info",
    element: (
      <Suspense fallback={<div>Loading General Info...</div>}>
        <GeneralInfo />
      </Suspense>
    ),
  },
  {
    path: ":id/projects",
    element: (
      <Suspense fallback={<div>Loading Projects...</div>}>
        <Projects />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<div>Loading Projects Table...</div>}>
            <ProjectList />
          </Suspense>
        ),
      },
      {
        path: ":projectId",
        element: <ProjectTabs />,
        children: [
          {
            path: "details",
            element: (
              <Suspense fallback={<div>Loading Project Details...</div>}>
                <ProjectDetails />
              </Suspense>
            ),
          },
          {
            path: "members",
            element: (
              <Suspense fallback={<div>Loading Project Members...</div>}>
                <ProjectMembers />
              </Suspense>
            ),
          },
          {
            path: "components",
            element: (
              <Suspense fallback={<div>Loading Projects Components...</div>}>
                <ProjectComponents />
              </Suspense>
            ),
          },
          {
            path: "active-workflow",
            element: (
              <Suspense
                fallback={<div>Loading Projects active workflow...</div>}
              >
                <ProjectActiveWorkFlow />
              </Suspense>
            ),
          },
          {
            path: "work-items",
            element: (
              <Suspense fallback={<div>Loading Projects work items...</div>}>
                <ProjectWorkItems />
              </Suspense>
            ),
          },
          {
            path: "custom-fields",
            element: (
              <Suspense fallback={<div>Loading Projects work items...</div>}>
                <ProjectCustomFields />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
  {
    path: ":id/members",
    element: (
      <Suspense fallback={<div>Loading members ...</div>}>
        <TeamMembers />
      </Suspense>
    ),
  },
  {
    path: ":id/billing",
    element: (
      <Suspense fallback={<div>Loading billing...</div>}>
        <Billing />
      </Suspense>
    ),
  },
  {
    path: ":id/addons",
    element: (
      <Suspense fallback={<div>Loading add ons ...</div>}>
        <h1 className=" px-6 ">Coming soon......</h1>
      </Suspense>
    ),
  },
  {
    path: ":id/import-export",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <ImportExportIndex />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <ImportExportRoot />
          </Suspense>
        ),
      },
      {
        path: "import",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <ImportIndex />
          </Suspense>
        ),
        children: [
          {
            index: true,
            replace: true,
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <ImportDestination />
              </Suspense>
            ),
          },
          {
            path: ImportSteps.importDestination,
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <ImportDestination />
              </Suspense>
            ),
          },
          {
            path: ImportSteps.uploadFile,
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <UploadFile />
              </Suspense>
            ),
          },
          {
            path: ImportSteps.mapFields,
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <MapFields />
              </Suspense>
            ),
          },
          {
            path: ImportSteps.stagedData,
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <StagedData />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "export",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Export />
          </Suspense>
        ),
      },
    ],
  },

  {
    path: ":id/security",
    element: (
      <Suspense fallback={<div>Loading security ...</div>}>
        <h1 className=" px-6 ">Coming soon......</h1>
      </Suspense>
    ),
  },
  {
    path: ":id/audit-logs",
    element: (
      <Suspense fallback={<div>Loading audit log...</div>}>
        <AuditLogs />
      </Suspense>
    ),
  },
  {
    path: ":id/archives",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Archives />
      </Suspense>
    ),
  },
  {
    path: ":id/settings",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <MySettingFeatures />
      </Suspense>
    ),
  },

  {
    path: ":id/notifications",
    element: (
      <Suspense fallback={<div>Loading notifications...</div>}>
        <Notification />
      </Suspense>
    ),
  },
  {
    path: ":id/referrals",
    element: (
      <Suspense fallback={<div>Loading referrals...</div>}>
        <h1 className=" px-6 ">Coming soon......</h1>
      </Suspense>
    ),
  },
  { path: "*", element: <h1 className=" px-6 ">Not Found</h1> },
];

export default TeamSettingRouting;
